module.exports = __webpack_public_path__ + "img/网站3-69.ef07e5e1.png";